@if (componentData.product$ | async; as product) {
  <div class="info-container">
    <boels-product-identifier [product]="product"></boels-product-identifier>
  </div>
}
